// TODO: jobにないID,消されたIDがlocalstorageに入っていたときにページャがおかしくなる

// phpから受け取った変数
const toJsParam = $('#common-script-js').data('to-js-param')
const toJsParamArray = toJsParam.split(',')
const templateDirectoryUri = toJsParamArray[0]
const baseUrl = toJsParamArray[1]

// 1ページあたりの表示件数
NUM_PER_PAGE = 6

// お気に入りページ
if (document.getElementById('favorite') != null) {
  let savedFavorites = getSavedFavorites()
  const favoriteLabel = $('.js-favorite-label')

  // 初回表示
  $(function() {
    // console.log('favorites:', savedFavorites)
    if (!savedFavorites) {
      let Dom =
        '<p class="p-job-list__none">お気に入り登録された仕事はありません</p>'
      fadeInJobs()
      $('#jobItems').html(Dom)
      return
    }
    ajaxFavorites(savedFavorites)
    // ページャ ページ数
    const numAllPage =
      savedFavorites.length % NUM_PER_PAGE
        ? savedFavorites.length / NUM_PER_PAGE + 1
        : savedFavorites.length / NUM_PER_PAGE

    let pagerDom = ''
    for (let i = 1; i <= numAllPage; i++) {
      const current = i === 1 ? 'current' : ''
      pagerDom =
        pagerDom +
        `<li><span class="page-numbers ${current}" data-num="${i}">${i}</span></li>`
    }
    $('ul.page-numbers').html(pagerDom)
  })

  // チェックボックスクリックしたら
  $(document).on('click', favoriteLabel, function(e) {
    if (e.target.value) {
      saveFavorites(savedFavorites)
    }
  })

  // ページネーションクリックしたら
  $(document).on('click', $('page-numbers'), function(e) {
    if (e.target.getAttribute('data-num')) {
      $(window).scrollTop(0)
      $('.p-job-list').fadeOut(300)
      let pageNum = 0
      savedFavorites = getSavedFavorites()
      pageNum = e.target.getAttribute('data-num')

      ajaxFavorites(savedFavorites, pageNum)

      $('span.page-numbers').each(function(i, e) {
        $(e).removeClass('current')
      })
      e.target.classList.add('current')
    }
  })
}

// トップページ、job一覧、 job詳細
if (
  document.getElementById('home') != null ||
  document.getElementById('archive-job') != null ||
  document.getElementById('single-job') != null
) {
  const favoriteLabel = $('.js-favorite-label')
  const savedFavorites = getSavedFavorites()
  // 初回表示
  $(function() {
    // 表示されているjobでループ
    favoriteLabel.each(function(i, e) {
      const ID = $(e)
        .find($("input[type='checkbox']"))
        .val()
      // localStorageに存在するIDだったら checkedにしておく
      if ($.inArray(ID, savedFavorites) !== -1) {
        $(e)
          .find($("input[type='checkbox']"))
          .prop('checked', true)
      }
    })
  })

  // チェックボックスクリックしたら
  $(document).on('click', favoriteLabel, function() {
    saveFavorites(savedFavorites)
  })
}

/**
 * ここから関数
 *  */

// お気に入りされたjobを返す
function getSavedFavorites() {
  // 登録されたお気に入りを配列にする
  const favoritesSaved = localStorage.getItem('favorites')
  if (favoritesSaved !== null && favoritesSaved !== '') {
    return favoritesSaved.split(',')
  }

  return
}

// Ajax呼び出し
function ajaxFavorites(favoritesSaved, pageNum = 1) {
  const start = (pageNum - 1) * NUM_PER_PAGE
  let showJobIDs = favoritesSaved.slice(start, start + NUM_PER_PAGE)
  $.ajax({
    type: 'POST',
    url: baseUrl + '/wp-admin/admin-ajax.php',
    dataType: 'json',
    data: {
      IDs: showJobIDs,
      action: 'favorite'
    },
    success: function(data) {
      showDom(data)
    },
    error: function(error) {
      console.log(error)
    }
  })
}

const showDom = function(data) {
  fadeInJobs()
  let Dom = ''
  data.forEach(object => {
    if (object.post_type === 'job' && object.is_publish) {
      let conditions
      if (object.conditions) {
        object.conditions.forEach(elm => {
          conditions += `<li class="c-job-item__conditions__item">
          <a href="../jobs/details/${elm.slug}.html">${elm.title}</a>
        </li>`
        })
      }

      let titleDom = ''
      let entryBtnDom = ''
      if (object.job_isfix === '1') {
        titleDom = `
        <h3 class="c-job-item__job-name">
          <p class="c-job-item__job-isfix">※この案件はご好評により定員となりました。</p>
          <p class="c-job-item__job-isfix__job-name">${object.title}</p>
        </h3>`
        entryBtnDom = `<span class="c-button--entry c-button--entry--medium c-job-item__entry --grayout"><span class="c-button--entry__text --large">応募画面に進む</span><span class="c-button--entry__text --small">約1分で完了します</span></span>`
      } else {
        titleDom = `
        <h3 class="c-job-item__job-name">
          ${object.title}
        </h3>`
        entryBtnDom = `<a href="./entry?jobId=${object.ID}" class="c-button--entry c-button--entry--medium c-job-item__entry"><span class="c-button--entry__text --large">応募画面に進む</span><span class="c-button--entry__text --small">約1分で完了します</span></a>`
      }

      Dom =
        Dom +
        `<article class="c-job-item">
        <header class="c-job-item__hedaer">
          ${titleDom}
        </header>
        <div class="c-job-item__body">
          <div class="c-job-item__information">
            <div class="c-job-item__information__inner">
              <div class="c-job-item__image">
                <img src="${object.image}" alt="" />
              </div>
              <div class="c-job-item__table">
                <table class="c-table">
                  <tr>
                    <th>おおお職種</th>
                    <td>${object.occupation}</td>
                  </tr>
                  <tr>
                    <th>CADソフト</th>
                    <td>${object.cadsoft}</td>
                  </tr>
                  <tr>
                    <th>企業</th>
                    <td>${object.company}</td>
                  </tr>
                  <tr>
                    <th>勤務地</th>
                    <td>${object.workarea}</td>
                  </tr>
                  <tr>
                    <th>勤務時間</th>
                    <td>${object.worktime}</td>
                  </tr>
                  <tr>
                    <th>給与</th>
                    <td>${object.salary}</td>
                  </tr>
                </table>
              </div>
          </div>
          <ul class="c-job-item__conditions">

          </ul>
        </div>
        <div class="c-job-item__conversion-item">
          <label class="c-job-item__favorit c-favorit-item js-favorite-label">
            <input type="checkbox" class="c-favorit-item__checkbox" value="${object.ID}" checked />
            <span class="c-job-item__favorit__label">お気に入り登録</span>
          </label>
          <a href="${object.permalink}" class="c-job-item__show-detail">求人を見る</a>
          ${entryBtnDom}
        </div>
      </article>`
    } else {
      Dom =
        Dom +
        `<article class="c-job-item">
      <header class="c-job-item__hedaer">
        <h3 class="c-job-item__job-name">
          公開終了しました
        </h3>
      </header></article>`
    }
  })

  $('#jobItems').html(Dom)
}

// localStorate のfavorites の値を更新する
function saveFavorites(savedFavorites) {
  if (!savedFavorites) {
    savedFavorites = []
  }
  const favoriteLabel = $('.js-favorite-label')
  let favoriteFalses = [] // このページのfalses
  let favoriteTrues = [] // このページのtrues
  let newFavorites = []
  // 表示されているjobでループ
  favoriteLabel.each(function(i, e) {
    if (
      $(e)
        .find("input[type='checkbox']")
        .prop('checked')
    ) {
      favoriteTrues.push(
        $(e)
          .find("input[type='checkbox']")
          .val()
      )
    } else {
      favoriteFalses.push(
        $(e)
          .find("input[type='checkbox']")
          .val()
      )
    }
  })
  // favoriteTruesを追加
  favoriteTrues.forEach(value => {
    if (savedFavorites.indexOf(value) === -1) {
      savedFavorites.push(value)
    }
  })
  // favoriteFalsesを削除
  newFavorites = savedFavorites.filter(function(v) {
    return !favoriteFalses.includes(v)
  })

  localStorage.setItem('favorites', newFavorites)
  // console.log('保存されてるやつ：', getSavedFavorites())
}

// お気に入りのDomを表示
function fadeInJobs() {
  $('.p-job-list').fadeIn(300)
}
